import { DrawerBody, DrawerBodyProps } from '@fluentui/react-components';


interface DrawerBodyCustomProps {
    rcName?: string;
}

const DrawerBodyCustom = (props: DrawerBodyCustomProps & DrawerBodyProps) => {
    return (
        <DrawerBody {...props}/>
    );
};

export default DrawerBodyCustom;